import { render } from "./toTopComponent.vue?vue&type=template&id=07cd14ce&scoped=true"
import script from "./toTopComponent.vue?vue&type=script&lang=js"
export * from "./toTopComponent.vue?vue&type=script&lang=js"

import "./toTopComponent.vue?vue&type=style&index=0&id=07cd14ce&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd14ce"]])

export default __exports__